import { InjectionToken } from '@angular/core';

export const GOOGLE_ANALYTICS_ID = new InjectionToken<string>('ID of the Google Analytics console');
